package fr.frux.shared.dto

import kotlinx.serialization.Serializable

/**
 * Requete de la boite a suggestions d'especes (#233) : un journal libre, distinct du circuit
 * structure de proposition (`species.proposed_by`). Les bornes de [name]/[comment] vivent dans
 * `SpeciesSuggestionLimits` (`backend-shared`), partagees entre ce DTO et la validation serveur.
 */
@Serializable
data class SpeciesSuggestionRequest(
    val name: String,
    val comment: String? = null,
)
